import React from 'react'
import {useIntl} from 'react-intl'
import {toAbsoluteUrl} from '../../../../_gori/helpers'
import {Button} from '../../../../_gori/partials/widgets'
import {useNavigate} from 'react-router-dom'
import {ROUTES} from '../../../../_gori/constants'

const GetStarted = () => {
  const intl = useIntl()
  const navigate = useNavigate()

  const connectToStore = () => {
    navigate(ROUTES.SETTINGS.CONNECTIONS.BASE)
  }

  const uploadCSV = () => {
    navigate(ROUTES.BATCHES.BASE)
  }

  const createManually = () => {
    navigate(ROUTES.ORDERS.CREATE)
  }

  return (
    <div className='get-started position-absolute top-50 start-50 translate-middle text-center w-100 mw-500px bg-transparent'>
      <div className='mb-4'>
        <img
          alt='delivery-completed'
          src={toAbsoluteUrl('/media/gori/orders/delivery-completed.gif')}
          className='delivery-completed'
        />
      </div>

      <h5 className='mb-6 text-dark fs-1 fw-bolder'>
        {intl.formatMessage({id: 'LET_GET_STARTED'})}
      </h5>
      <div className='buttons d-flex flex-column flex-md-row justify-content-center align-items-center gap-3'>
        <Button
          className='btn btn-connect-a-store text-white fw-bolder px-5 py-4 cursor-pointer w-100 w-md-auto'
          label={intl.formatMessage({id: 'START_CONNECT_A_STORE'})}
          loadingText={intl.formatMessage({id: 'START_CONNECT_A_STORE'})}
          disabled={false}
          event={connectToStore}
        />
        <Button
          className='btn btn-upload-csv text-white fw-bolder px-5 py-4 cursor-pointer w-100 w-md-auto'
          label={intl.formatMessage({id: 'UPLOAD_CSV'})}
          loadingText={intl.formatMessage({id: 'UPLOAD_CSV'})}
          disabled={false}
          event={uploadCSV}
        />
        <Button
          className='btn btn-create-manually text-white fw-bolder px-5 py-4 cursor-pointer w-100 w-md-auto'
          label={intl.formatMessage({id: 'CREATE_MANUALLY'})}
          loadingText={intl.formatMessage({id: 'CREATE_MANUALLY'})}
          disabled={false}
          event={createManually}
        />
      </div>
    </div>
  )
}

export {GetStarted}
